import { Form, FormikProvider, useFormik } from "formik";
// material
import { LoadingButton } from "@mui/lab";
import { Alert, Stack, TextField } from "@mui/material";
// routes
// hooks
import { useSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import useIsMountedRef from "../../../hooks/useIsMountedRef";
import baseService from "../../../services/base.service";

// ----------------------------------------------------------------------
type InitialValues = {
  company_name: string;
  afterSubmit?: string;
};
export default function CompanyForm() {
  const isMountedRef = useIsMountedRef();
  const { enqueueSnackbar } = useSnackbar();
  const { login, isAuthenticated, companyInfo } = useAuth();
  const location = useLocation();
  const intendedDestination = location.pathname + location.search;

  const initAuthentication = async (companyName: string) => {
    try {
      const { data } = await baseService.get(
        `/company/get-auth-config-by-company-identity?identity=${companyName}`,
      );
      const authConfig = data?.data;

      if (!authConfig) {
        enqueueSnackbar("Şirket bilgileri bulunamadı", {
          variant: "error",
        });
        return;
      }

      // Eğer zaten giriş yapılmışsa ve farklı bir şirket ile giriş yapılmaya çalışılıyorsa uyarı ver
      if (isAuthenticated && companyInfo?.companyId !== authConfig?.companyId) {
        enqueueSnackbar(
          `Farklı şirket ile giriş yapılmaya çalışılıyor. Önceki oturum kapatılacak.`,
          { variant: "warning" },
        );
      }

      switch (authConfig.authType) {
        case "ADFS":
          sessionStorage.setItem("postLoginRedirect", intendedDestination);
          window.location.replace(
            `${authConfig.authUrl}&username=${companyName}/`,
          );
          break;

        case "AzureEntraId":
          await login(authConfig, intendedDestination);
          break;
        case "SAML":
          sessionStorage.setItem("postLoginRedirect", intendedDestination);
          window.location.replace(`${data.authUrl}&username=${companyName}/`);
          break;
        default:
          enqueueSnackbar("Bu şirkete ait bilgi bulunamadı", {
            variant: "error",
          });
      }
    } catch (error: any) {
      console.log(error);
      enqueueSnackbar("Şirket bilgileri alınamadı", {
        variant: "error",
      });
    }
  };

  const formik = useFormik<InitialValues>({
    initialValues: {
      company_name: "",
    },
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      try {
        await initAuthentication(values.company_name);

        if (isMountedRef.current) {
          setSubmitting(false);
        }
      } catch (error: any) {
        console.log(error);
        if (error.status === 403 || !!error.email) {
          //navigate(PATH_AUTH.verify, { state: { email: error.email } });
        }
        resetForm();
        if (isMountedRef.current) {
          setSubmitting(false);
          setErrors({ afterSubmit: "Giriş Bilgilerinizi Kontrol Ediniz" });
        }
      }
    },
  });

  const { errors, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={2}>
          {errors.afterSubmit && (
            <Alert severity="error">{errors.afterSubmit}</Alert>
          )}
          <Stack spacing={1}>
            {/*<Typography variant="subtitle2" color="text.primary">
              Şirket Kimliği
            </Typography>*/}
            <TextField
              fullWidth
              autoComplete="company_name"
              type="text"
              label="Şirket Kimliği"
              {...getFieldProps("company_name")}
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "common.black",
                  },
                },
                "& label.Mui-focused": {
                  color: "common.black",
                },
              }}
            />
          </Stack>
        </Stack>
        <Stack sx={{ mt: 3 }}>
          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            sx={{
              bgcolor: "common.black",
              boxShadow: (theme) => theme.shadows[8],
              "&:hover": { bgcolor: "grey.900" },
            }}
          >
            Giriş Yap
          </LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
